import React from "react"
import {
  Basic,
  BasicWithOwner,
  CreditCard,
  ESA,
  Mortgage,
  Retirement,
  RothRetirement,
  RothIRA,
  TermLife,
  TermLoan,
  AutoLoan,
  StudentLoan,
  PrivateStudentLoan,
  ESRPLoan
} from "./AccountDetailsView/worksheetTypes"

export const accountTypesData = [
  {
    type: "savings",
    label: "Savings",
    icon: "money",
    view: Basic,
    description: (
      <span>
        A savings account is a simple financial account that allows you to
        securely store cash and earn interest. A savings account is typically
        held at a bank or a credit union.
      </span>
    ),
    category: "bank",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: false
  },
  {
    type: "checking",
    label: "Checking",
    icon: "money",
    view: Basic,
    description: (
      <span>
        A checking account is a simple financial account that allows you to
        store cash and write checks or use a debit card to spend that cash. A
        checking account is typically held at a bank or a credit union.
      </span>
    ),
    category: "bank",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: false
  },
  {
    type: "creditcard",
    label: "Credit Card",
    icon: "credit card",
    view: CreditCard,
    description: (
      <span>
        We all know and love our credit cards. A credit card allows us to buy
        things without carrying around cash, or even having the cash at all! Of
        course, this flexibility doesn't come for free. We'll have to pay for it
        eventually and with interest if we don't pay off our balance before the
        next credit card bill comes.
      </span>
    ),
    category: "creditcard",
    askDistributions12m: false,
    askContributions12m: false,
    askYtd: false
  },
  {
    type: "401k",
    label: "401(k)",
    icon: "bar chart",
    view: Retirement,
    description: (
      <span>
        A 401(k) is an employer-sponsored retirement account. Contributions are{" "}
        <i>not</i> included in your taxable income (decreasing your current
        income taxes) while retirement distributions <i>are</i> included in your
        taxable income (increasing your future income taxes).
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "roth401k",
    label: "Roth 401(k)",
    icon: "bar chart",
    view: RothRetirement,
    description: (
      <span>
        A Roth 401(k) is an employer-sponsored retirement account. Contributions{" "}
        <i>are</i> included in your taxable income while qualified retirement
        distributions are <i>not</i> included in your taxable income (decreasing
        your future income taxes).
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "403b",
    label: "403(b)",
    icon: "bar chart",
    view: Retirement,
    description: (
      <span>
        A 403(b) is an employer-sponsored retirement account. Contributions are{" "}
        <i>not</i> included in your taxable income (decreasing your current
        income taxes) while retirement distributions <i>are</i> included in your
        taxable income (increasing your future income taxes).
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "roth403b",
    label: "Roth 403(b)",
    icon: "bar chart",
    view: RothRetirement,
    description: (
      <span>
        A Roth 403(b) is an employer-sponsored retirement account. Contributions{" "}
        <i>are</i> included in your taxable income while qualified retirement
        distributions are <i>not</i> included in your taxable income (decreasing
        your future income taxes).
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "457b",
    label: "457(b)",
    icon: "bar chart",
    view: Retirement,
    description: (
      <span>
        A 457(b) is an employer-sponsored retirement account. Contributions are{" "}
        <i>not</i> included in your taxable income (decreasing your current
        income taxes) while retirement distributions <i>are</i> included in your
        taxable income (increasing your future income taxes).
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "roth457b",
    label: "Roth 457(b)",
    icon: "bar chart",
    view: RothRetirement,
    description: (
      <span>
        A Roth 457(b) is an employer-sponsored retirement account. Contributions{" "}
        <i>are</i> included in your taxable income while qualified retirement
        distributions are <i>not</i> included in your taxable income (decreasing
        your future income taxes).
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "hsa",
    label: "Health Savings Account",
    icon: "doctor",
    view: BasicWithOwner,
    description: (
      <span>
        A Health Savings Account (HSA) is a tax advantaged medical savings
        account available when you are enrolled in a high-deductible health
        plan. HSA funds can be used to pay for qualified medical expenses with
        no tax penalty.
      </span>
    ),
    category: "health",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "ira",
    label: "IRA",
    icon: "bar chart",
    view: Retirement,
    description: (
      <span>
        A Traditional IRA is an individual retirement account. Contributions are{" "}
        <i>not</i> included in your taxable income (decreasing your current
        income taxes) while retirement distributions <i>are</i> included in your
        taxable income (increasing your future income taxes).
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "rothira",
    label: "Roth IRA",
    icon: "bar chart",
    view: RothIRA,
    description: (
      <span>
        A Roth IRA is an individual retirement account. Contributions <i>are</i>{" "}
        included in your taxable income while retirement distributions are{" "}
        <i>not</i> included in your taxable income (decreasing your future
        income taxes).
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "studentloan",
    label: "Federal Student Loan",
    icon: "graduation cap",
    view: StudentLoan,
    description: (
      <span>
        Student loans help students pay for college or graduate school. You
        often get a tax deduction on interest payments for student loans used
        only for qualified educational expenses. Federal or State programs may
        offer a variety of different features not available for standard term
        loans like income-driven repayment, subsidized interest, deferment, and
        forgiveness.
      </span>
    ),
    category: "loan"
  },
  {
    type: "privatestudentloan",
    label: "Private Student Loan",
    icon: "graduation cap",
    view: PrivateStudentLoan,
    description: (
      <span>
        Private Student Loans are issued to help students pay for college or
        graduate school. In contrast with Federal Student Loans, Private Student
        Loans are fixed-term loans issued by private lenders. You might get a
        tax deduction on interest payments for private loans when used only for
        qualified educational expenses.
      </span>
    ),
    category: "loan"
  },
  {
    type: "esrploan",
    label: "Retirement Plan Loan",
    icon: "bar chart",
    view: ESRPLoan,
    description: (
      <span>
        An existing loan you've taken from an active retirement plan like a
        401(k) or 403(b).
      </span>
    ),
    category: "loan",
    askDistributions12m: false,
    askContributions12m: false,
    askYtd: false
  },
  {
    type: "brokerage",
    label: "Brokerage",
    icon: "bar chart",
    view: BasicWithOwner,
    description: (
      <span>
        A brokerage account is a type of taxable account that allows you to
        purchase stocks or other investments.
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: false
  },
  {
    type: "frm",
    label: "Mortgage",
    icon: "university",
    view: Mortgage,
    description: (
      <span>
        A mortgage is a loan given to you by a lender, such as a bank, to help
        you finance a home purchase. A mortgage is different from other types of
        loans because the home serving as collateral for the debt typically
        maintains or appreciates in value, unlike most cars or boats.
      </span>
    ),
    category: "loan",
    askDistributions12m: false,
    askContributions12m: false,
    askYtd: false
  },
  {
    type: "autoloan",
    label: "Auto Loan",
    icon: "car",
    view: AutoLoan,
    description: (
      <span>
        An auto loan is a loan from a bank or other lender for a specific amount
        that has a specified repayment schedule and interest rate.
      </span>
    ),
    category: "loan",
    askDistributions12m: false,
    askContributions12m: false,
    askYtd: false
  },
  {
    type: "termloan",
    label: "Term Loan",
    icon: "university",
    view: TermLoan,
    description: (
      <span>
        A term loan is a loan from a bank or other lender for a specific amount
        that has a specified repayment schedule and interest rate.
      </span>
    ),
    category: "loan",
    askDistributions12m: false,
    askContributions12m: false,
    askYtd: false
  },
  {
    type: "529",
    label: "529 Plan Account",
    icon: "student",
    view: ESA,
    description: (
      <div>
        <p>
          A 529 Plan is a tax-advantaged educational savings plan where you can
          set aside after-tax dollars; any earnings accumulate on a tax-deferred
          basis. Distributions for qualified educational expenses are tax-free.
        </p>
      </div>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "coverdell",
    label: "Coverdell Account",
    icon: "student",
    view: ESA,
    description: (
      <span>
        A Coverdell account is a tax-advantaged educational savings accounts
        where can you save your taxable income and then distribute without
        paying taxes for qualified educational purposes, including some K-12
        costs.
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "termlife",
    label: "Term Life Insurance",
    icon: "shield",
    view: TermLife,
    description: (
      <span>
        Term Life Insurance pays a benefit to your beneficiary if you pass away
        during a specific period of time (known as a “term”). The cost of life
        insurance varies and is generally based on your age and how much
        coverage you elect.
      </span>
    ),
    category: "insurance",
    askDistributions12m: false,
    askContributions12m: false,
    askYtd: false
  },
  {
    type: "simpleira",
    label: "SIMPLE IRA",
    icon: "bar chart",
    view: BasicWithOwner,
    description: (
      <span>
        A SIMPLE IRA is a savings incentive match plan for an employee's
        individual retirement account. Contributions are <i>not</i> included in
        your taxable income (decreasing your current income taxes) while
        retirement distributions <i>are</i> are included in your taxable income
        (increasing your future income taxes).
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "sepira",
    label: "SEP IRA",
    icon: "bar chart",
    view: BasicWithOwner,
    description: (
      <span>
        A SEP IRA is a traditional individual retirement account (IRA) used for
        employer-only contributions made through a SEP Plan.
      </span>
    ),
    category: "investment",
    askDistributions12m: true,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "401a",
    label: "401(a)",
    icon: "bar chart",
    view: BasicWithOwner,
    description: (
      <span>
        A 401(a) is a less common employer-sponsored retirement plan that is
        most frequently encountered by employees of government agencies,
        educational institutions or non-profits. The employer may contribute
        directly, may require the employee to contribute, may allow voluntary
        contributions from the employee, or some combination of these options.
      </span>
    ),
    category: "investment",
    askDistributions12m: false,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "457f",
    label: "457(f)",
    icon: "bar chart",
    view: BasicWithOwner,
    description: (
      <span>
        A 457(f) is an employer-sponsored non-qualified deferred compensation
        plan.
      </span>
    ),
    category: "investment",
    askDistributions12m: false,
    askContributions12m: true,
    askYtd: true
  },
  {
    type: "other",
    label: "Other Taxable",
    icon: "money",
    view: Basic,
    description: (
      <span>
        A taxable account that doesn't match one of the other taxable account
        types like savings, checking or brokerage.
      </span>
    ),
    category: "bank",
    askDistributions12m: false,
    askContributions12m: false,
    askYtd: false
  }
]

// // add account types currently in development but not yet released to production
// if (process.env.REACT_APP_DEPLOY_ENV !== "production") {
//   accountTypesData.push()
// }

export const accountTypes = Object.assign(
  {},
  ...accountTypesData.map(account => ({ [account["type"]]: account }))
)

export const accountCategoryLabels = new Map([
  ["bank", "Checking and Savings"],
  ["creditcard", "Credit Cards"],
  ["loan", "Mortgages and other loans"],
  ["investment", "Investment accounts"],
  ["health", "Health Accounts"],
  ["insurance", "Insurance Accounts"]
])
